var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textarea',{ref:"input",staticClass:"input-text-area",domProps:{"value":_vm.value ?? ''},on:{"input":_setup.onInput,"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }